let config = null;

async function value(name) {
  // Dev mode.
  const v = process.env["REACT_APP_" + name];
  if (v) {
    return v;
  }
  if (config === null) {
    config = await loadConfig();
  }
  return config[name];
}

async function loadConfig() {
  const response = await fetch('/config.json');
  if (!response.ok) {
    throw new Error(`HTTP error: status: ${response.status}`);
  }
  return await response.json();
}

export const SERVER_URL = await value("SERVER_URL");
export const PAYPAL_CLIENT_ID = await value("PAYPAL_CLIENT_ID");
